import {  Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'enum-dropdown',
  templateUrl: './enum-dropdown.component.html',
  styleUrls: ['./enum-dropdown.component.css']
})
export class EnumDropdownComponent implements OnInit {

  selectedItems = [];
  dropdownSettings:IDropdownSettings = {};
  placeholder:string;
  placeholderText: string;
  validatorRequired: boolean = false;

  public enumDropdownForm: FormGroup;

  items: any[] = [];

  @Output() selectedChange = new EventEmitter<any[]>();
  @Input() public required: boolean;
  @Input() public singleSelection: boolean = false;
  @Input() public showLabel: boolean = true;


  @Input() set selected(value: any[])
  {
    this.preSelect = value;
    if (this.enumDropdownForm) this.setPreSelect(value);
    };

  preSelect: any[];

  constructor(
    public translate: TranslateService,
    public fb: FormBuilder) {
      this.dropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'name',
        tooltipField: 'description',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        closeDropDownOnSelection: false,
        allowRemoteDataSearch: false
      };
  }

  ngOnInit(): void {
    // required at least one selected or not
    this.validatorRequired = this.required;
    //change dropdownSettings if necessary
    this.dropdownSettings.singleSelection = this.singleSelection;
    if (this.singleSelection)
      this.dropdownSettings.closeDropDownOnSelection = true;

    this.translate
    .get([this.placeholderText])
    .subscribe((translations: string) => {
      this.placeholder = translations[this.placeholderText];
    });

    this.enumDropdownForm = this.fb.group({
      selected: [[this.selectedItems], this.validatorRequired ? Validators.required : []]
    });

    this.getItems();
  }

  getItems(): void {
    this.selectedItems = [];

  }

  onSelect(item: any){
    let s = this.selectedItems.map((it) => it);
    let its: any[] = this.items.filter((it) =>
    {
      return s.includes(it);
    });

    this.selectedChange.emit(its);
  }

  onSelectAll(event: any){
    let s = this.selectedItems.map((it) => it);

    this.selectedChange.emit(this.items);
  }

  onItemDeSelect(item: any){
    let s = this.selectedItems.map((it) => it);
    let its: any[] = this.items.filter((it) =>
    {
      return s.includes(it);
    });

    this.selectedChange.emit(its);
  }

  setPreSelect(items: any[])
  {
    this.selectedItems = [];
    if (items)
    {
      items.forEach(el => {
        if (el)
          this.selectedItems.push(el);
      });
    }

    this.enumDropdownForm.patchValue({
      selected: this.selectedItems
    });
  }

  onFilterChange(filter: any)
  {
    console.log("catch the on search " + filter);
  }


}
